export default "__VITE_ASSET__Ce_Sv3Vm__"